export const Info = (props) => {
  const { size = 16, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_689_56946)'>
          <path
            d='M8.00016 10.6668V8.00016M8.00016 5.3335H8.00683M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668C4.31826 14.6668 1.3335 11.6821 1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335C11.6821 1.3335 14.6668 4.31826 14.6668 8.00016Z'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_689_56946'>
            <rect width='16' height='16' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};
